// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3xVbn","footer":"ModalError_footer__2-GF6"};